import { useContext } from "react";
import { Navigate, NavLink, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { routePaths } from "../constants/routes";

function AccessState({ eyebrow, title, message, actionLabel, actionTo }) {
  return (
    <section className="access-state-page">
      <div className="access-state-card surface-card">
        <span className="ui-badge">{eyebrow}</span>
        <h1>{title}</h1>
        <p>{message}</p>
        {actionLabel && actionTo && (
          <NavLink className="btn-ui" to={actionTo}>
            {actionLabel}
          </NavLink>
        )}
      </div>
    </section>
  );
}

export default function ProtectedRoute({ children, allowedRoles = [] }) {
  const { user, role, userData, loading } = useContext(AuthContext);
  const location = useLocation();

  if (loading) {
    return (
      <AccessState
        eyebrow="Checking access"
        title="Loading your dashboard..."
        message="We are verifying your session and role before opening this page."
      />
    );
  }

  if (!user) {
    return <Navigate to={routePaths.login} replace state={{ from: location.pathname }} />;
  }

  if (userData && userData.isActive === false) {
    return (
      <AccessState
        eyebrow="Account inactive"
        title="Your account needs activation."
        message="Your account is currently inactive. Please contact QA Coder support to activate access."
        actionLabel="Contact Support"
        actionTo={routePaths.contact}
      />
    );
  }

  if (userData && userData.onboardingCompleted === false && location.pathname !== routePaths.onboarding) {
    return <Navigate to={routePaths.onboarding} replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(role)) {
    return (
      <Navigate
        to={routePaths.unauthorized}
        replace
        state={{
          from: location.pathname,
          requiredRoles: allowedRoles,
        }}
      />
    );
  }

  return children;
}
